export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="flex flex-wrap justify-between gap-4 border-t border-ink-200 pb-7 pt-[18px] font-mono text-[10.5px] uppercase tracking-[0.14em] text-muted">
      <p>© {year} FoundFoundry</p>
      <p>Made in Uruguay</p>
      <p>Display: RST Reactor VF · Text: Newsreader</p>
    </footer>
  );
}
